export default __webpack_public_path__ + "images/d3b592fee7856bc89e8fd9e5412edda8-information-stroke.svg";